import request from "../composables/useHttp";


/**
 * @description: 获取企业荣誉
 * */
export function getCorporateHonors() {
    return request("/company-honor/gw/findGWCompanyHonor", {
        method: 'get',
    })
}


/**
 * @description: 获取路桥旗下
 * */
export function getIts() {
    return request("/sub-company/gw/findGWSubCompany", {
        method: 'get',
    })
}


/**
 * @description: 获取路桥旗下公司详情
 * */
export function getItsDetail(subCompanyId) {
    return request("/sub-company/gw/findSubCompanyDetailById", {
        method: 'get',
        params: {subCompanyId}
    })
}

/**
 * @description: 获取路桥旗下公司详情得相关公司列表
 * */
export function getGWRecommendedSubCompany(subCompanyId) {
    return request("/sub-company/gw/findGWRecommendedSubCompany", {
        method: 'get',
        params: {subCompanyId}
    })
}


/**
 * @description: 获取推荐新闻
 * */
export function getRecommendedNews() {
    return request('/news/gw/findGWRecommendNews', {
        method: 'get',
    })
}